import projectsData from '../data/projects.json';
import sandboxCards from '../data/sandbox.json';
import kitchenSessionsCards from '../data/project-cards/kitchen-sessions-cards.json';

// Per-project page config. Each entry extends the /projects page defaults.
// cover & bgTarget fall back to the Projects page values when omitted.
// component: optionally import a custom JSX component to override the template.
//   e.g: import EchoesPage from '../pages/projects/EchoesPage.jsx';
//        { slug: 'echoes-of-silence', component: EchoesPage, ... }
// cards: optionally import a JSON file to render a Cards list on the template.
//   e.g: import echoesCards from '../data/project-cards/echoes-cards.json';
//        { slug: 'echoes-of-silence', cards: echoesCards, ... }
// showTitle: set to false to hide the <h1> in the header cover-container.
//   e.g: { slug: 'echoes-of-silence', showTitle: false, ... }
// callout: renders a CalloutCard inside #cover-container instead of the <h1> title.
//   e.g: { slug: 'echoes-of-silence', callout: { title: 'Hello', subtitle: 'World', iframeSrc: '...', cta: { label: 'Listen', href: '/music' } } }
export const projectPages = [
  { 
    slug: 'echoes-of-silence',      
    theme: 'black', 
    bgTarget: 'body',  
    cover: null,
    cards: sandboxCards,
  },
  { 
    slug: 'kitchen-sessions',
    theme: 'light',
    bgTarget: 'cover',
    cover: null,
    cards: kitchenSessionsCards,
  },
  { 
    slug: 'live-sessions-vol-1',    
    theme: 'light', 
    bgTarget: 'cover', 
    cover: null 
  },
  { 
    slug: 'collaborative-ep-minds', 
    theme: 'light', 
    bgTarget: 'cover', 
    cover: null 
  },
  { 
    slug: 'visual-score-series',    
    theme: 'black', 
    bgTarget: 'body',  
    cover: null 
  },
  { 
    slug: 'the-sound-archive',      
    theme: 'black', 
    bgTarget: 'body',  
    cover: null 
  },
];

const projectPageMap = Object.fromEntries(projectPages.map(p => [p.slug, p]));

// Returns per-project page config. cover: null means inherit from /projects.
export function getProjectPage(slug) {
  return projectPageMap[slug] ?? null;
}

// Returns the cards array for a project, or null.
export function getProjectCards(slug) {
  return projectPageMap[slug]?.cards ?? null;
}

// Nav children for the Projects dropdown — derived from projects.json order.
export const projectNavChildren = projectsData.map(({ slug, title }) => ({
  to: `/projects/${slug}`,
  label: title,
}));
